import React from 'react';
import Async from 'react-select/async';
import { locationStore } from 'components/settings/locations/LocationStore';

export class LocationDropdown extends React.Component {
	state = {
		loaded: false
	};

	async componentDidMount() {
		this.setState({ loaded: true });
	}

	render() {
		if (this.state.loaded) {
			const { placeholder = 'Location' } = this.props;

			return (
				<Async
					menuPosition="fixed"
					maxMenuHeight="300"
					className={
						'react-select ' +
						(this.props.styleVersion ? this.props.styleVersion : '') +
						(this.props.isInvalid ? ' has-error' : '')
					}
					classNamePrefix={
						this.props.classNamePrefix ||
						'react-select' +
							(this.props.styleVersion ? `-${this.props.styleVersion}` : '')
					}
					cacheOptions
					isMulti={this.props.isMulti}
					value={this.props.value}
					placeholder={placeholder}
					defaultOptions
					isClearable
					loadOptions={this.loadOptions}
					getOptionValue={this.getOptionValue}
					getOptionLabel={this.getOptionLabel}
					noOptionsMessage={this.noOptionsMessage}
					onChange={item => {
						if (this.props.onValueChange) {
							this.props.onValueChange(item);
						}
					}}
				/>
			);
		} else {
			return null;
		}
	}

	loadOptions = inputValue => {
		return new Promise(resolve => {
			resolve(this.getLocations(inputValue));
		});
	};

	getLocations = async inputValue => {
		inputValue = inputValue.trim();
		const result = await locationStore.getLocations(inputValue);
		return result.data;
	};

	noOptionsMessage = value => {
		if (value.inputValue && value.inputValue.length >= 2) {
			return 'No matches found';
		} else {
			return 'Enter text to search locations';
		}
	};

	getOptionValue = option => option.id;

	getOptionLabel = option => `${option.name}`;
}
